// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21nVo","label":"styles_label__34bdQ"};